// Bridge JS → app Flutter wrapper (community-mobile).
// Chamadas viram no-op no navegador puro (sem app), ficam ativas no WebView.

declare global {
  interface Window {
    SispoliBridge?: { postMessage: (msg: string) => void }
  }
}

function send(payload: object) {
  if (typeof window === 'undefined') return
  if (!window.SispoliBridge) return
  try {
    window.SispoliBridge.postMessage(JSON.stringify(payload))
  } catch {
    // bridge indisponível / ambiente sem app — silenciar
  }
}

export const sispoliBridge = {
  notifyLogin(token: string) {
    send({ type: 'auth.login', token })
  },
  notifyLogout() {
    send({ type: 'auth.logout' })
  },
}
